import React from 'react';
import { LANGUAGE_CN } from '@/pages/home/_config/config';

import type { IRegion, ISelectOptionWithGroup } from '@/pages/intelligence/types/common';

export const getTextWithLocale = (enText: string, chText: string, locale: string): string =>
  locale === LANGUAGE_CN ? chText : enText;

type IAnalysisResult = {
  options: ISelectOptionWithGroup[];
  values: string[];
  groups: {
    [key: string]: React.ReactNode;
  };
};
export const analysisRegionsCountriesData = (
  regionsCountries: IRegion[],
  locale: string,
): IAnalysisResult => {
  const result: IAnalysisResult = {
    options: [],
    values: [],
    groups: {},
  };
  if (!Array.isArray(regionsCountries)) return result;
  for (const regionCountries of regionsCountries) {
    const {
      area_code: areaCode,
      area_name_en: areaNameEN,
      area_name_ch: areaNameCH,
      country_set: countries,
    } = regionCountries ?? {};
    if (!Array.isArray(countries) || !countries.length) continue;
    for (const country of countries) {
      const {
        country_code: countryCode,
        country_name_en: countryNameEN,
        country_name_ch: countryNameCH,
      } = country ?? {};
      const countryName = getTextWithLocale(countryNameEN, countryNameCH, locale);
      result.options.push({
        label: countryName,
        text: countryName,
        value: countryCode,
        groupKey: areaCode,
        text_cn: countryNameCH,
        text_en: countryNameEN,
      });
      result.values.push(countryCode);
    }
    result.groups[areaCode] = getTextWithLocale(areaNameEN, areaNameCH, locale);
  }
  return result;
};

type IGetSearcherFilterRes = (
  codeSearchable: boolean,
  allLocaleSearchable?: boolean,
) => (keywords: string, option: any) => boolean;

export const getSearcherFilter: IGetSearcherFilterRes =
  (codeSearchable, allLocaleSearchable) => (keywords, option) => {
    try {
      const reg = new RegExp(keywords ?? '', 'gi'); // 模糊匹配正则
      const label = option?.label ?? '';
      const value = option?.value ?? '';
      const textCN = option?.text_cn ?? '';
      const textEN = option?.text_en ?? '';

      // 搜索简写
      const isLabelValueMatch = (label && reg.test(label)) || (value && reg.test(value));
      if (codeSearchable && isLabelValueMatch) {
        return true;
      }

      const isLocaleTextMatch = (textCN && reg.test(textCN)) || (textEN && reg.test(textEN));
      if (allLocaleSearchable && (isLabelValueMatch || isLocaleTextMatch)) {
        return true;
      }

      return !!(label && reg.test(label));
    } catch (exception) {
      console.error(exception);
    }
    return true;
  };
